import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

/**
 * Enum for deleted status filter values
 * These values are used in the deletedAt filter field of search body schemas
 */
export enum DeletedStatus {
  /** Shows only active (non-deleted) records where deletedAt IS NULL */
  ACTIVE = "IS_NULL",
  /** Shows only deleted records where deletedAt IS NOT NULL */
  DELETED = "IS_NOT_NULL",
}

/**
 * Type for search body schemas that support deletedAt filtering
 */
export interface DeletableSearchBody {
  deletedAt?: string[];
}

/**
 * Filter for showing/hiding deleted records
 * Can be used with any entity that has a deletedAt field in its search body
 */
export class DeletedStatusFilter extends Filter<DeletableSearchBody, never> {
  readonly id: string = "deletedAt";
  readonly labelSingular = "common:Status";
  readonly labelPlural = "common:Status";
  readonly placeholder = "common:SelectStatus";
  readonly searchPlaceholder = "common:SearchStatus";
  readonly emptyText = "common:NoStatusFound";

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    const options: Array<{ id: DeletedStatus; name: string }> = [
      { id: DeletedStatus.ACTIVE, name: "common:Active" },
      { id: DeletedStatus.DELETED, name: "common:Deleted" },
    ];

    return {
      options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
